import Home2 from './Home2';

// Mesma tela de Home2, filtrada para a série especial "Cristo Cura Sim".
export default function Cristocurasim() {
    return <Home2 especialFixo="Cristo Cura Sim" />;
}
